import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AdvisoryModel } from '../data';
import { AdvisoryModelProvider } from '../providers/advisory-model-provider.service';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetAdvisoryModelsUseCaseService implements UseCase<Observable<Transaction<AdvisoryModel[]>>> {
    constructor(private advisoryModelProvider: AdvisoryModelProvider) {}

    bind(): Observable<Transaction<AdvisoryModel[]>> {
        return this.advisoryModelProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (advisoryModel) => Transaction.success(cloneDeep(advisoryModel)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
